"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAdaptableOptions = void 0;
const tslib_1 = require("tslib");
const GeneralConstants = tslib_1.__importStar(require("../Constants/GeneralConstants"));
const GeneralConstants_1 = require("../Constants/GeneralConstants");
const UIHelper_1 = tslib_1.__importStar(require("../../View/UIHelper"));
const AdaptablePredicate_1 = require("../../PredefinedConfig/Common/AdaptablePredicate");
const Enums_1 = require("../../PredefinedConfig/Common/Enums");
const ModuleConstants = tslib_1.__importStar(require("../../Utilities/Constants/ModuleConstants"));
// change type to DeepRequired<AdaptableOptions> to check which properties have no default values defined
exports.DefaultAdaptableOptions = {
    adaptableId: GeneralConstants.ADAPTABLE_ID,
    adaptableStateKey: undefined,
    primaryKey: '',
    autogeneratePrimaryKey: false,
    userName: GeneralConstants.USER_NAME,
    predefinedConfig: undefined,
    alertOptions: {
        alertForms: undefined,
        maxAlertsInStore: 20,
        cellHighlightDuration: 2000,
        rowHighlightDuration: 4000,
        statusbarHighlightDuration: 2000,
        dataChangeDetectionPolicy: 'rawValue',
        actionHandlers: undefined,
        alertMessageText: undefined,
        showMissingPrimaryKeyAlert: false,
    },
    notificationsOptions: {
        maxNotifications: 3,
        position: 'BottomRight',
        duration: 3000,
        showProgressBar: false,
        closeWhenClicked: false,
        pauseWhenHovering: false,
        isDraggable: false,
        transition: 'Slide',
        showApplicationIcon: false,
        showSystemStatusMessageNotifications: false,
        maxSystemMessagesInStore: 100,
    },
    dataImportOptions: {
        fileHandlers: undefined,
    },
    flashingCellOptions: {
        defaultFlashDuration: 500,
        defaultFlashTarget: 'cell',
        defaultDownChangeStyle: {
            BackColor: (0, UIHelper_1.getHexForName)(UIHelper_1.RED),
        },
        defaultUpChangeStyle: {
            BackColor: (0, UIHelper_1.getHexForName)(UIHelper_1.GREEN),
        },
        defaultNeutralChangeStyle: {
            BackColor: (0, UIHelper_1.getHexForName)(UIHelper_1.GRAY),
        },
    },
    expressionOptions: {
        evaluateAdaptableQLExternally: undefined,
        displayColumnFriendlyNamesForExpressions: true,
        systemBooleanFunctions: undefined,
        systemScalarFunctions: undefined,
        systemObservableFunctions: undefined,
        systemAggregatedBooleanFunctions: undefined,
        systemAggregatedScalarFunctions: undefined,
        moduleExpressionFunctions: undefined,
        performExpressionValidation: true,
        maxTimeframeSize: 28800000,
        caseSensitiveExpressions: false,
    },
    calendarOptions: { holidays: undefined },
    cellSummaryOptions: { cellSummaryOperations: undefined },
    containerOptions: {
        adaptableContainer: 'adaptable',
        agGridContainer: 'grid',
        agGridContainerWaitTimeout: 60000,
        modalContainer: undefined,
        systemStatusContainer: undefined,
        alertContainer: undefined,
    },
    columnOptions: {
        columnFriendlyName: undefined,
        columnTypes: GeneralConstants_1.EMPTY_ARRAY,
        showMissingColumnsWarning: true,
        addColumnGroupToColumnFriendlyName: false,
    },
    dashboardOptions: {
        canFloat: true,
        showQuickSearchInHeader: true,
        customDashboardButtons: undefined,
        customToolbars: undefined,
        buttonsLocation: 'right',
    },
    actionColumnOptions: {
        actionColumns: undefined,
    },
    actionRowOptions: {
        actionRowButtons: undefined,
        autoHandle: true,
        disableInlineEditing: false,
        setPrimaryKeyValue: undefined,
        actionRowButtonOptions: {
            customConfiguration: undefined,
            position: 'pinnedLeft',
        },
        actionRowFormOptions: {
            formTitle: undefined,
            formDescription: undefined,
            formFieldLabel: undefined,
            formButtons: undefined,
            onFormSubmit: undefined,
        },
    },
    editOptions: {
        validateOnServer: undefined,
        displayServerValidationMessages: true,
        isCellEditable: undefined,
        smartEditCustomOperations: undefined,
    },
    entitlementOptions: {
        defaultAccessLevel: 'Full',
        moduleEntitlements: undefined,
    },
    exportOptions: {
        exportFormatType: 'rawValue',
        exportDateFormat: undefined,
        customDestinations: undefined,
        externalReports: undefined,
        appendFileTimestamp: false,
        systemExportDestinations: [
            Enums_1.ExportDestination.Excel,
            Enums_1.ExportDestination.CSV,
            Enums_1.ExportDestination.Clipboard,
            Enums_1.ExportDestination.JSON,
            Enums_1.ExportDestination.Table,
        ],
        systemReportNames: [
            GeneralConstants.ALL_DATA_REPORT,
            GeneralConstants.CURRENT_DATA_REPORT,
            GeneralConstants.VISUAL_DATA_REPORT,
            GeneralConstants.SELECTED_CELLS_REPORT,
            GeneralConstants.SELECTED_ROWS_REPORT,
        ],
        reportFilename: undefined,
    },
    customSortOptions: { customSortComparers: undefined },
    dataSetOptions: { dataSets: GeneralConstants_1.EMPTY_ARRAY },
    groupingOptions: {
        showGroupingTotalsAsHeader: false,
        unbalancedGroupsKey: undefined,
        restoreUngroupedColumns: false,
        autoOrderGroupedColumns: true,
    },
    formatColumnOptions: {
        customDisplayFormatters: undefined,
    },
    layoutOptions: {
        displayRowGroups: 'closed',
        autoSaveLayouts: true,
        autoSizeColumnsInLayout: false,
        autoSizeColumnsInPivotLayout: false,
        createDefaultLayout: false,
        layoutViewOptions: {
            maxColumnsToDisplay: 10,
        },
        layoutTagOptions: {
            autoGenerateTagsForLayouts: false,
            isObjectAvailableInLayout: undefined,
            autoCheckTagsForLayouts: false,
        },
    },
    menuOptions: {
        customColumnMenu: undefined,
        customContextMenu: undefined,
        showAdaptableContextMenu: true,
        showAdaptableColumnMenu: true,
        showUngroupColumnMenuItem: true,
        columnMenuOrder: ['aggrid', 'adaptable', 'user'],
        contextMenuOrder: ['aggrid', 'adaptable', 'user'],
        columnMenuItems: undefined,
        contextMenuItems: undefined,
    },
    columnFilterOptions: {
        quickFilterOptions: {
            hideQuickFilterDropdown: undefined,
            hideQuickFilterInput: undefined,
            quickFilterTrigger: 'mouseenter',
            quickFilterDebounce: 250,
            quickFilterHeight: null,
            showQuickFilter: true,
            quickFilterWildcards: {},
            quickFilterValuesWidth: 180,
        },
        filterFormOptions: {
            useAgGridFilterFormStyle: true,
            defaultFilterFormTab: 'Values',
        },
        valuesFilterOptions: {
            valuesFilterTrigger: 'mouseenter',
            sortValuesFilter: false,
            filterValuesUsingTime: false,
            showDistinctFilteredValuesOnly: false,
            maxFilterValuesToDisplay: 2000,
            includeBlankFilterValues: false,
            showValuesCount: undefined,
        },
        indicateFilteredColumns: true,
        useAdaptableColumnFiltering: true,
        clearColumnFiltersOnStartUp: false,
        filterActionOnUserDataChange: {
            applyFilter: GeneralConstants.FILTER_ALWAYS,
            throttleDelay: 0,
        },
        filterActionOnExternalDataChange: {
            applyFilter: GeneralConstants.FILTER_NEVER,
            throttleDelay: 0,
        },
        autoApplyFilter: true,
        defaultNumericColumnFilter: 'Equals',
        defaultStringColumnFilter: 'Contains',
        defaultDateColumnFilter: 'On',
        enableFilterOnSpecialColumns: true,
        showClearFilterButton: false,
        showSuspendFilterButton: false,
    },
    gridFilterOptions: {
        availableFilterEditors: ['ExpressionEditor', 'QueryBuilder'],
        clearGridFilterOnStartUp: false,
    },
    predicateOptions: {
        customPredicateDefs: [],
        systemFilterPredicates: AdaptablePredicate_1.SystemFilterPredicateIds,
        systemAlertPredicates: AdaptablePredicate_1.SystemAlertPredicateIds,
        systemFormatColumnPredicates: AdaptablePredicate_1.SystemFormatColumnPredicateIds,
        systemFlashingCellPredicates: AdaptablePredicate_1.SystemFlashingCellPredicateIds,
        systemBadgeStylePredicates: AdaptablePredicate_1.SystemBadgeStylePredicateIds,
        caseSensitivePredicates: false,
    },
    quickSearchOptions: {
        excludeColumnFromQuickSearch: undefined,
        runQuickSearchOnRowGroups: true,
        runQuickSearchOnPivotColumns: true,
        clearQuickSearchOnStartUp: false,
        quickSearchPlaceholder: 'Search',
        filterResultsAfterQuickSearch: false,
        runQuickSearchWithCaseSensitivity: false,
        runBespokeQuickSearch: undefined,
    },
    stateOptions: {
        debounceStateDelay: 400,
        applyState: (state) => state,
        saveState: (state) => state,
        loadState: undefined,
        persistState: undefined,
        clearState: undefined,
    },
    teamSharingOptions: {
        enableTeamSharing: false,
        persistSharedEntities: undefined,
        loadSharedEntities: undefined,
        applySharedEntities: (sharedEntities) => sharedEntities,
        saveSharedEntities: (sharedEntities) => sharedEntities,
        updateInterval: 0,
        updateNotification: undefined,
        suppressOverrideConfigWarning: false,
        showUpdateNotificationOncePerUpdate: false,
    },
    userInterfaceOptions: {
        alternativeModuleNames: undefined,
        applicationIcon: undefined,
        useCustomMacLikeScrollbars: false,
        englishVariant: 'GB',
        showLoadingScreen: true,
        disableDeleteConfirmation: false,
        dateInputOptions: {
            useNativeInput: false,
            dateFormat: 'yyyy-MM-dd',
            // locale is not explicitly defaulted to 'en-US' as this is already done by the react-day-picker
            showWeekNumber: false,
            showOutsideDays: true,
            datepickerButtons: ['close', 'today'],
        },
        colorPalette: UIHelper_1.default.getDefaultColors(),
        editableCellStyle: undefined,
        readOnlyCellStyle: undefined,
        styleClassNames: GeneralConstants_1.EMPTY_ARRAY,
        permittedValues: undefined,
        editLookUpItems: undefined,
        showDocumentationLinks: true,
        showAdapTableVersion: true,
    },
    toolPanelOptions: {
        showToolPanelsDropdown: true,
        customButtons: undefined,
        customToolPanels: undefined,
    },
    dataChangeHistoryOptions: {
        activeByDefault: false,
        showDataChange: undefined,
        changeHistoryButton: undefined,
    },
    settingsPanelOptions: {
        popupType: 'window',
        title: ModuleConstants.SettingsPanelFriendlyName,
        icon: 'ConfigurationIcon',
        navigation: {},
        alwaysShowInDashboard: false,
        alwaysShowInToolPanel: false,
    },
    chartingOptions: {
        saveStrategy: 'none',
        agGridContainerName: GeneralConstants.AG_GRID_CHART_WINDOW,
        externalChartingOptions: {},
    },
    fdc3Options: {
        enableLogging: false,
        actionColumnDefaultConfiguration: {
            columnId: 'fdc3ActionColumn',
            headerName: 'FDC3 Actions',
            width: 200,
            resizable: true,
            movable: false,
        },
        uiControlsDefaultConfiguration: {
            // default config is set in FDC3 Service, to make it easier to overview
            contexts: {},
            intents: {},
        },
    },
};
